export default `# Devices

The devices panel manages physical avatar hardware — small displays and cameras that bring avatars into the room. Pair devices to avatars, capture images, and add visual content to your session.

---

## Pairing Devices

Click **Pair Device** to see available hardware. For each device:
1. Select which **avatar** to assign it to (or use as a standalone camera)
2. Choose a **lease duration** (1h, 2h, 4h, 8h, or 24h)
3. Click **Pair**

Devices show their capabilities, for example camera and microphone.

---

## Device Cards

Each paired device displays:
- **Device ID** and avatar assignment
- **Battery level** — Colour-coded (green >75%, amber 25–75%, red <25%) with charging indicator
- **WiFi status** — Online (green) or offline (gray)
- **Capabilities** — What the device can do
- **Lease status**:
  - **Active** (green) — Working normally
  - **Warning** (amber, pulsing) — Lease expiring soon, click **Renew**
  - **Expired** (red) — Lease ended, device needs re-pairing

### Camera Controls
For devices with cameras:
- **Capture interval** — Set auto-capture frequency: Disabled, every 30s, 1m, 2m, or 5m
- **Capture Now** — Take a photo immediately

Click **Unpair** to release a device.

---

## Captured Images

All images appear in a gallery grid below the device cards.

### Uploading Images
Click **Upload Image** to manually add photos (e.g. whiteboard snapshots, sketches). Supports JPEG, PNG, and WebP.

### Image Actions
- **Click** any thumbnail to see the full image and metadata
- **Select** images with checkboxes for bulk deletion
- **Extracted Text** — OCR results are shown for each image in a scrollable text box
- **Add to Context** — Include the extracted text in the session's AI context, so avatars can reference what's on the whiteboard or document

---

## Tips

- **Set capture intervals for whiteboards** — Auto-capture at 2–5 minute intervals to track how the whiteboard evolves
- **Add extracted text to context** — This lets avatars "see" physical whiteboards and documents, bridging the physical-digital gap
- **Renew leases before they expire** — An expired lease disconnects the device mid-session
- **Upload manual photos** when auto-capture isn't available — Phone photos of sketches and notes work well`;
